export default "__VITE_ASSET__ca866bc1__"